import React from 'react';

import { RegionFilter } from 'src/modules/designStudio/components/DesignMenu/Filters/RegionFilter/RegionFilter';
import { MenuHeader } from 'src/modules/designStudio/components/DesignMenu/Menu/MenuHeader';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

type CryptomatteRegionMenuProps = {
  category: 'WALLS' | 'ROOFS' | 'TRIM';
  regionIds: string[];
  closeMenu: () => void;
  onRegionSelection: (regionId: string) => void;
};
export const CryptomatteRegionMenu = ({
  category,
  closeMenu,
  onRegionSelection,
  regionIds,
}: CryptomatteRegionMenuProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);

  return (
    <>
      <MenuHeader
        closeMenu={closeMenu}
        disableDisclaimer
        headerText={t(`menu.cryptomatteRegions.${category}.title`)}
      />
      <RegionFilter onClick={onRegionSelection} regionIds={regionIds} />
    </>
  );
};
